import { render, staticRenderFns } from "./OwnerListItems.vue?vue&type=template&id=67bb13e0"
import script from "./OwnerListItems.vue?vue&type=script&lang=js"
export * from "./OwnerListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports